export default __webpack_public_path__ + "static/media/policyup.062b7572.svg";